import React from 'react'
import { Link } from 'react-router-dom'
import {
    FiHome,
    FiInfo,
    FiMail,
    FiFileText,
    FiShield,
} from 'react-icons/fi'
import { FaHeart } from 'react-icons/fa'

const navLinks = [
    { to: '/', label: 'Home', icon: FiHome },
    { to: '/about', label: 'About', icon: FiInfo },
    { to: '/contact', label: 'Contact', icon: FiMail },
    { to: '/terms', label: 'Terms', icon: FiFileText },
    { to: '/privacy', label: 'Privacy', icon: FiShield },
]

export default function Footer({ isForLogin = false }) {
    const year = new Date().getFullYear()

    const credit = (
        <span className="text-gray-500">
            © {year}{' '}
            <a
                className="font-medium text-brand-600 transition-colors hover:text-brand-700"
                href="https://cubicleeight.com"
                target="_blank"
                rel="noreferrer"
            >
                Cubicle Eight
            </a>
            . All rights reserved.
        </span>
    )

    // Login page ke liye compact version
    if (isForLogin) {
        return <span className="text-xs">{credit}</span>
    }

    return (
        <footer className="border-t border-gray-100 bg-white">
            {/* Mobile: py-2.5 (bahut kam height) | Desktop: py-4 */}
            <div className="mx-auto max-w-7xl px-3 py-2.5 sm:px-6 sm:py-4 lg:px-8">
                <div className="flex flex-col items-center gap-1.5 sm:gap-3 md:flex-row md:justify-between">

                    {/* Nav links — mobile pe chhote, tight pills */}
                    <nav
                        aria-label="Footer navigation"
                        className="flex flex-wrap items-center justify-center gap-x-0.5 sm:gap-x-1.5"
                    >
                        {navLinks.map(({ to, label, icon: Icon }) => (
                            <Link
                                key={to}
                                to={to}
                                className="group flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] text-gray-600 transition-colors hover:bg-brand-50 hover:text-brand-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 sm:gap-1.5 sm:rounded-lg sm:px-2.5 sm:py-1.5 sm:text-sm"
                            >
                                <Icon
                                    size={13}
                                    className="shrink-0 text-gray-400 transition-colors group-hover:text-brand-500"
                                    aria-hidden="true"
                                />
                                <span>{label}</span>
                            </Link>
                        ))}
                    </nav>

                    {/* Credit + tagline — mobile pe ek hi choti line */}
                    <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[11px] sm:text-sm">
                        {credit}
                        {/* Tagline mobile pe hidden — space bachane ke liye */}
                        <span className="hidden items-center gap-1 text-gray-400 sm:flex">
                            Made with
                            <FaHeart
                                size={12}
                                className="text-brand-500"
                                aria-hidden="true"
                            />
                            in India
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    )
}